import React from "react";
function AggHostedNonSeamless() {
  return (
    <div class="idocs-content">
      <div class="container">
        <div class="row">
          <div class="col-md-8">
            <section id="idocs_content" class="mt-20 mb-20">
              <h2> Aggregator Hosted (Non-Seamless)</h2>
              <hr />
            </section>

            <p>
              Avoid struggling to develop and manage your checkout page. Use the
              customized payment page provided by <b>Safexpay</b> , enabling you
              to collect payment from the customer.
            </p>

            <p>
              <b>Safexpay</b> payment page is fully customized, enabling you to
              match the look and feel of your website with respect to Font and
              Colors.
            </p>

            <p>
              Processing orders using <b>Safexpay</b> payment page.
            </p>

            {/* Aggregator Hosted (Non-Seamless) flow dig: strat */}

            <div className="img-div">
              <img src="assets/images/Devdoc1.png" alt="logo" />
            </div>

            {/* Aggregator Hosted (Non-Seamless) flow dig. end */}

            <u>
              <h4>Process flow</h4>
            </u>

            <ul>
              <li>
                <p>
                  Customer selects product/service on your website and proceeds
                  to make payment.
                </p>
              </li>
              <li>
                <p>
                  Customer is redirected to the <b>Safexpay</b> payment page
                  where payment information is entered by the customer.
                </p>
              </li>
              <li>
                <p>
                  On submission of the transaction information, <b>Safexpay</b>{" "}
                  initiates the authorization process by connecting to the
                  relevant bank / processing organization.
                </p>
              </li>
              <li>
                <p>
                  On receiving the authorization status from the bank,{" "}
                  <b>Safexpay</b> sends the response back to your website with
                  the transaction status.
                </p>
              </li>
            </ul>

            <section id="idocs_content" class="mt-20 mb-20">
              <h2>
                Safexpay Test Environments for Aggregator Hosted (Non-Seamless)
              </h2>
              <hr />
            </section>

            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr>
                  <td className="table-color">Post URL</td>
                  <td>
                    {/* <a href="https://uatcheckout.safexpay.ae/ms-transaction-core-1-0/paymentRedirection/checksumGatewayPage">
                      https://uatcheckout.safexpay.ae/ms-transaction-core-1-0/paymentRedirection/checksumGatewayPage{" "}
                    </a> */}
                    <p>
                      https://uatcheckout.safexpay.ae/ms-transaction-core-1-0/paymentRedirection/checksumGatewayPage
                    </p>
                  </td>
                </tr>
                <tr>
                  <td className="table-color">Merchant ID</td>
                  <td>202402140001</td>
                </tr>
                <tr>
                  <td className="table-color">Encryption Key</td>
                  <td>m0BK5EtM1W8QTldL6cjEEH7Ljr7zLUs+j8xZU2Nr/OY=</td>
                </tr>
                <tr>
                  <td className="table-color">Aggregator ID</td>
                  <td> paygate</td>
                </tr>
              </tbody>
            </table>

            <u>
              <h4>Request Parameters</h4>
            </u>

            <p>
              Merchant must send the following parameters to{" "}
              <b className="para-blod">Safexpay</b> PG for processing an order.
            </p>

            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr className="table-main-title">
                  <th colSpan={7}>
                    Section: Txn_Details (Required Parameters)
                  </th>
                </tr>
                <tr className="table-color">
                  <th>Parameter Name</th>
                  <th>Mandate</th>
                  <th> Type (length)</th>
                  <th>Description</th>
                </tr>
                <tr>
                  <td>ag_id</td>
                  <td>YES</td>
                  <td>Alphabets (11)</td>
                  <td>Aggregator id is “paygate”</td>
                </tr>

                <tr>
                  <td>me_id</td>
                  <td>YES</td>
                  <td> Numeric (20)</td>
                  <td>MerchantID issued to you by Safexpay.</td>
                </tr>

                <tr>
                  <td>order_no</td>
                  <td>YES</td>
                  <td>Alphanumeric (70)</td>
                  <td>
                    {" "}
                    This ID is used by merchants to identify the order. Ensure
                    that you send a <b>unique id</b> with each request. As it
                    generates a unique payment reference number for each order
                    which is sent by the merchant.
                  </td>
                </tr>

                <tr>
                  <td>Amount</td>
                  <td>YES</td>
                  <td> Numeric (20,2)</td>
                  <td>
                    This is your Transaction Amount. You can use up to 2 decimal
                    places. E.g., “150.00”
                  </td>
                </tr>

                <tr>
                  <td>Country</td>
                  <td>YES</td>
                  <td>Alphabets (3)</td>
                  <td>
                    Country code needs to be passed, Country code as “ARE” for
                    United Arab Emirates . “ITA” for Italy. “USA” for United
                    states of America. “GBR” for Great Britain.
                  </td>
                </tr>

                <tr>
                  <td>Currency</td>
                  <td>YES</td>
                  <td>Alphabets (3)</td>
                  <td>
                    Currency in which you want to process the transaction. AED -
                    Emirati Dirham USD - United States Dollar GBP - Pound
                    Sterling EUR - Euro
                  </td>
                </tr>

                <tr>
                  <td>txn_type</td>
                  <td>YES</td>
                  <td> Alphabets (10)</td>
                  <td>
                    Use Txn_Type as <b> “SALE” </b> which is static with each
                    request
                  </td>
                </tr>

                <tr>
                  <td>success_url</td>
                  <td>YES</td>
                  <td>
                    Alphanumeric (200) <b>Characters allowed :</b> Alphabet
                    (A-Z), (a-z), Numbers, / (slash), _ (underscore)
                  </td>
                  <td>
                    This will be the return URL where response is accepted for
                    successful transaction.
                  </td>
                </tr>

                <tr>
                  <td>failure_url</td>
                  <td>YES</td>
                  <td>
                    Alphanumeric (200 <b>Characters allowed :</b> Alphabet
                    (A-Z), (a-z) Numbers, / (slash), _ (underscore)
                  </td>
                  <td>
                    This will be the return URL where response is accepted for
                    failed transaction.
                  </td>
                </tr>

                <tr>
                  <td>Channel</td>
                  <td>YES</td>
                  <td>Alphabet (10)</td>
                  <td>
                    Use <b>“WEB”</b> in case of website-based payment or{" "}
                    <b>“MOBILE”</b> in case of mobile app. Static value with
                    each request.
                  </td>
                </tr>
              </tbody>
            </table>

            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr className="table-main-title">
                  <th colSpan={7}>Section: pg_details</th>
                </tr>
                <tr className="table-color">
                  <th>Parameter Name</th>
                  <th>Mandate</th>
                  <th> Type (length)</th>
                  <th>Description</th>
                </tr>
                <tr>
                  <td>pg_id</td>
                  <td>NO</td>
                  <td>Numeric (11)</td>
                  <td>
                    This is the Bank Identification code assigned by Safexpay
                    Team only{" "}
                    <b>if the Integration type is Merchant Hosted (SEAMLESS)</b>{" "}
                    otherwise the value must be blank in the request.
                  </td>
                </tr>

                <tr>
                  <td>Paymode</td>
                  <td>NO</td>
                  <td> Alphabets (2)</td>
                  <td>
                    This is the Paymode Identification code assigned by Safexpay
                    Team only
                    <b>
                      if the Integration type is Merchant Hosted (SEAMLESS)
                    </b>{" "}
                    otherwise the value must be blank in the request.
                  </td>
                </tr>

                <tr>
                  <td>Scheme</td>
                  <td>NO</td>
                  <td>Numeric (11)</td>
                  <td>
                    This is the Scheme Identification code assigned by Safexpay
                    Team only
                    <b>
                      if the Integration type is Merchant Hosted (SEAMLESS)
                    </b>{" "}
                    otherwise the value must be blank in the request.
                  </td>
                </tr>

                <tr>
                  <td>emi_months</td>
                  <td>NO</td>
                  <td> Numeric (11)</td>
                  <td>
                    Value must be blank for Aggregator Hosted (Non-Seamless)
                  </td>
                </tr>
              </tbody>
            </table>

            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr className="table-main-title">
                  <th colSpan={7}>Section: card_details</th>
                </tr>
                <tr className="table-color">
                  <th>Parameter Name</th>
                  <th>Mandate</th>
                  <th> Type (length)</th>
                  <th>Description</th>
                </tr>
                <tr>
                  <td>card_no</td>
                  <td>NO</td>
                  <td>Numeric (19)</td>
                  <td>
                    Value must be blank for Aggregator Hosted (Non-Seamless)
                  </td>
                </tr>

                <tr>
                  <td>exp_month</td>
                  <td>NO</td>
                  <td> Numeric (2)</td>
                  <td>
                    Value must be blank for Aggregator Hosted (Non-Seamless)
                  </td>
                </tr>

                <tr>
                  <td>exp_year</td>
                  <td>NO</td>
                  <td>Numeric (4)</td>
                  <td>
                    Value must be blank for Aggregator Hosted (Non-Seamless)
                  </td>
                </tr>

                <tr>
                  <td>cvv</td>
                  <td>NO</td>
                  <td> Numeric (3)</td>
                  <td>
                    Value must be blank for Aggregator Hosted (Non-Seamless)
                  </td>
                </tr>

                <tr>
                  <td>card_name</td>
                  <td>NO</td>
                  <td> Alphabets (50)</td>
                  <td>
                    Value must be blank for Aggregator Hosted (Non-Seamless)
                  </td>
                </tr>
              </tbody>
            </table>

            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr className="table-main-title">
                  <th colSpan={7}>Section: cust_details</th>
                </tr>
                <tr className="table-color">
                  <th>Parameter Name</th>
                  <th>Mandate</th>
                  <th> Type (length)</th>
                  <th>Description</th>
                </tr>
                <tr>
                  <td>cust_name</td>
                  <td>Optional</td>
                  <td>Alphabets (50)</td>
                  <td>
                    Customer Name. This is required required for fraud
                    protection.
                  </td>
                </tr>

                <tr>
                  <td>
                    email_id <b>(Mandatory)</b>{" "}
                  </td>
                  <td>YES</td>
                  <td>
                    Alphanumeric (100) Characters allowed: Alphabet (A-Z),
                    (a-z). Numbers @ (at), dot, _ (underscore)
                  </td>
                  <td>
                    Customer's Email ID. This is required required for fraud
                    protection.
                  </td>
                </tr>

                <tr>
                  <td>
                    mobile_no <b>(Mandatory)</b>
                  </td>
                  <td>YES</td>
                  <td>Numeric (15)</td>
                  <td>
                    Customer's Mobile Number. This is required required for
                    fraud protection.
                  </td>
                </tr>

                <tr>
                  <td>unique_id</td>
                  <td>NO</td>
                  <td> Alphanumeric (100)</td>
                  <td>
                    This is required in case of <b>Stored card feature.</b>
                  </td>
                </tr>

                <tr>
                  <td>is_logged_in</td>
                  <td>YES</td>
                  <td> Alphabets (1)</td>
                  <td>Pass “Y” if user is logged in</td>
                </tr>
              </tbody>
            </table>

            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr className="table-main-title">
                  <th colSpan={7}>Section: Bill_details</th>
                </tr>
                <tr className="table-color">
                  <th>Parameter Name</th>
                  <th>Mandate</th>
                  <th> Type (length)</th>
                  <th>Description</th>
                </tr>

                <tr>
                  <td>bill_addres</td>
                  <td>Optional</td>
                  <td>
                    {" "}
                    Alphanumeric (400) <b>Characters allowed:</b> Alphabet
                    (A-Z), (a-z). Numbers # (hash), Comma, circular brackets,
                    /(slash), dot,- (hyphen) Space in between words{" "}
                  </td>
                  <td>
                    Customer's Billing Address. This is required required for
                    fraud protection.
                  </td>
                </tr>

                <tr>
                  <td>bill_city</td>
                  <td>Optional</td>
                  <td>Optional (50)</td>
                  <td>
                    Customer's Billing City. This is required required for fraud
                    protection.
                  </td>
                </tr>

                <tr>
                  <td>bill_state</td>
                  <td>Optional</td>
                  <td>Alphabets (50)</td>
                  <td>
                    Customer's Billing State. This is required required for
                    fraud protection.
                  </td>
                </tr>
                <tr>
                  <td>bill_country</td>
                  <td>Optional</td>
                  <td>Alphabets (50)</td>
                  <td>
                    Customer's Billing Country.This is required required for
                    fraud protection.
                  </td>
                </tr>

                <tr>
                  <td>bill_zip</td>
                  <td>Optional</td>
                  <td>
                    {" "}
                    Alphanumeric (20)
                    <p>
                      Customer's Billing Zip/Pin Code.This is required for fraud
                      protection.
                    </p>
                    <b>Characters allowed:</b> Alphabet (A-Z),(a-z). Numbers
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>

            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr className="table-main-title">
                  <th colSpan={7}>Section: Ship_details</th>
                </tr>
                <tr className="table-color">
                  <th>Parameter Name</th>
                  <th>Mandate</th>
                  <th> Type (length)</th>
                  <th>Description</th>
                </tr>

                <tr>
                  <td>ship_address</td>
                  <td>Optional</td>
                  <td>
                    Alphanumeric (400) <b> Characters allowed:</b> Alphabet
                    (A-Z), (a-z). Numbers # (hash), Comma, circular brackets,
                    /(slash), dot,- (hyphen) Space in between words
                  </td>
                  <td>
                    Customer's Shipping Address. This is required in case of
                    physical delivery of goods.
                  </td>
                </tr>

                <tr>
                  <td>ship_city</td>
                  <td>Optional</td>
                  <td>Alphabets (50)</td>
                  <td>
                    Customer's Shipping City. This is required in case of
                    physical delivery of goods.
                  </td>
                </tr>

                <tr>
                  <td>ship_state</td>
                  <td>Optional</td>
                  <td>Alphabets (50)</td>
                  <td>
                    Customer's Shipping State. This is required in case of
                    physical delivery of goods.
                  </td>
                </tr>

                <tr>
                  <td>ship_country</td>
                  <td>Optional</td>
                  <td>Alphabets (50)</td>
                  <td>
                    Customer’s Shipping Country. This is required in case of
                    physical delivery of goods.
                  </td>
                </tr>

                <tr>
                  <td>ship_zip</td>
                  <td>Optional</td>
                  <td>
                    Alphanumeric (20)
                    <b>Characters allowed:</b> Alphabet (A-Z),(a-z). Numbers{" "}
                  </td>
                  <td>
                    Customer's Shipping Zip/Pin Code. This is required in case
                    of physical delivery of goods.
                  </td>
                </tr>

                <tr>
                  <td>ship_days</td>
                  <td>Optional</td>
                  <td>Numeric (11)</td>
                  <td>
                    Approximate number of days required for delivery of goods.
                    This is required in case of physical delivery of goods.
                  </td>
                </tr>

                <tr>
                  <td>address_count</td>
                  <td>Optional</td>
                  <td>Numeric (11)</td>
                  <td>
                    If customer has more than one addresses stored in your
                    system.
                  </td>
                </tr>
              </tbody>
            </table>

            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr className="table-main-title">
                  <th colSpan={7}>Section: Item_details</th>
                </tr>
                <tr className="table-color">
                  <th>Parameter Name</th>
                  <th>Mandate</th>
                  <th> Type (length)</th>
                  <th>Description</th>
                </tr>

                <tr>
                  <td>item_count</td>
                  <td>Optional</td>
                  <td>Alphanumeric (11)</td>
                  <td>Count of items purchased by customer.</td>
                </tr>

                <tr>
                  <td>item_value</td>
                  <td>Optional</td>
                  <td>Optional (200,2)</td>
                  <td>Comma separated item wise cost</td>
                </tr>

                <tr>
                  <td>item_category</td>
                  <td>Optional</td>
                  <td>Alphanumeric (200)</td>
                  <td>Comma separated item category. E.g., “DVD”</td>
                </tr>
              </tbody>
            </table>

            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr className="table-main-title">
                  <th colSpan={7}>Section: Other_details</th>
                </tr>
                <tr className="table-color">
                  <th>Parameter Name</th>
                  <th>Mandate</th>
                  <th> Type (length)</th>
                  <th>Description</th>
                </tr>

                <tr>
                  <td>udf_1</td>
                  <td>Optional</td>
                  <td>
                    {" "}
                    Alphanumeric (100) <b>Characters allowed:</b> Alphabet
                    (A-Z), (a-z). Numbers # (hash), Comma, circular
                    brackets,/(slash), dot, -(hyphen) Space in between words
                  </td>
                  <td>
                    This parameter can be used for sending additional
                    information about the transaction. PG will send this
                    parameter in the response.
                  </td>
                </tr>

                <tr>
                  <td>udf_2</td>
                  <td>Optional</td>
                  <td>
                    {" "}
                    Alphanumeric (100) <b>Characters allowed:</b> Alphabet
                    (A-Z), (a-z). Numbers # (hash), Comma, circular
                    brackets,/(slash), dot, -(hyphen) Space in between words
                  </td>
                  <td>
                    This parameter can be used for sending additional
                    information about the transaction. PG will send this
                    parameter in the response.
                  </td>
                </tr>

                <tr>
                  <td>udf_3</td>
                  <td>Optional</td>
                  <td>
                    {" "}
                    Alphanumeric (100) <b>Characters allowed:</b> Alphabet
                    (A-Z), (a-z). Numbers # (hash), Comma, circular
                    brackets,/(slash), dot, -(hyphen) Space in between words
                  </td>
                  <td>
                    This parameter can be used for sending additional
                    information about the transaction. PG will send this
                    parameter in the response.
                  </td>
                </tr>

                <tr>
                  <td>udf_4</td>
                  <td>Optional</td>
                  <td>
                    {" "}
                    Alphanumeric (100) <b>Characters allowed:</b> Alphabet
                    (A-Z), (a-z). Numbers # (hash), Comma, circular
                    brackets,/(slash), dot, -(hyphen) Space in between words
                  </td>
                  <td>
                    This parameter can be used for sending additional
                    information about the transaction. PG will send this
                    parameter in the response.
                  </td>
                </tr>

                <tr>
                  <td>udf_5</td>
                  <td>Optional</td>
                  <td>
                    {" "}
                    Alphanumeric (100) <b>Characters allowed:</b> Alphabet
                    (A-Z), (a-z). Numbers # (hash), Comma, circular
                    brackets,/(slash), dot, -(hyphen) Space in between words
                  </td>
                  <td>
                    This parameter can be used for sending additional
                    information about the transaction. PG will send this
                    parameter in the response.
                  </td>
                </tr>
              </tbody>
            </table>

            {/* <div className="note-div">
              <b className="aggHost-note">Note :</b>

              <p>
                Value in each section will be encrypted value generated in
                following way. Only me_id (Merchant ID) will bein plain text.
              </p>

              <p>
                Each attribute in every section is combined together separated
                with pipe (|). Make sure that you are sending the request in{" "}
                <b className="para-blod"> HTTP Form post method.</b>
              </p>

              <p>
                <b className="para-blod">Please find the formatshared below:</b>
              </p>
              <p>
                Transaction request is not compatible to run on{" "}
                <span className="highlighter-cusm">Postman Platform.</span>
              </p>
              <p>
                Transactions are only permitted through registered merchant
                domains. If “localhost” orlocal IP is notpermitted, you will get{" "}
                <b className="para-blod">“Invalid Referral URL.” </b> error in
                such case.
              </p>

              <p>
                Transaction request must be in below manner when it triggersto
                our Payment Gateway URL. Merchant mustsend the following
                parameters to the <b className="para-blod">Safexpay</b> PG which
                ismandatory, but values mightbe blank in case of optional or not
                required.
              </p>

              <p className="para-underline">
                Example of Transaction request in HTTP Form post method: Sample
                HTML transaction posting :
              </p>

              <ul>
                <li>
                  Make sure that you are sending the request in{" "}
                  <b className="para-blod"> HTTP Form post method.</b>
                </li>
                <li>
                  Transactions are only permitted through registered merchant
                  domains. If “localhost” or local IP is not permitted, you will
                  get <b className="para-blod">“Invalid Referral URL.” </b>{" "}
                  error in such case.
                </li>
                <li>
                  {" "}
                  Transaction request must be in below manner when it triggers
                  to our Payment Gateway URL.
                </li>
                <li>
                  {" "}
                  Merchant must send the following parameters to the{" "}
                  <b className="para-blod">Safexpay</b> PG which is mandatory,
                  but values might be blank in case of optional or not required
                </li>
              </ul>

              <p className="para-underline">
                Please note only HTML Form Submission with ‘POST’ method is only
                supported Sending payment request using any REST API call is
                notsupported.
              </p>
            </div> */}

            <div className="note-div">
              <b className="aggHost-note">Note :</b>

              <p>
                Value in each section will be encrypted value generated in the
                following way. Only me_id (Merchant ID) will be in plain text.
              </p>

              <p>
                Each attribute in every section is combined and separated with
                pipe (|). Make sure that you are sending the request in the
                <b className="para-blod"> HTTP Form post method.</b>
              </p>

              <p>
                <b className="para-blod">
                  Please find the format shared below:
                </b>
              </p>
              <p>
                The transaction request is not compatible with the{" "}
                <span className="highlighter-cusm">Postman Platform.</span>
              </p>

              <p>
                Transactions are only permitted through registered merchant
                domains. If “localhost” or local IP is not permitted, you will
                get an
                <b className="para-blod">“Invalid Referral URL.” </b> error in
                such case.
              </p>

              <p>
                Transaction requests must be in the manner below when it trigger
                to our Payment Gateway URL. Merchants must send the following
                parameters to the <b>Safexpay</b> PG, which is mandatory, but
                values might be blank if they are optional or not required.
              </p>

              <p className="para-underline">
                Example of the Transaction request in HTTP Form post method:
                Sample HTML transaction posting:
              </p>

              <ul>
                <li>
                  Make sure that you are sending the request in the
                  <b className="para-blod"> HTTP Form post method.</b>
                </li>
                <li>
                  Transactions are only permitted through registered merchant
                  domains. If “localhost” or local IP is not permitted, you will
                  get <b className="para-blod">“Invalid Referral URL.” </b>{" "}
                  error.
                </li>
                <li>
                  {" "}
                  Transaction request must be in the manner below when it
                  triggers to our Payment Gateway URL.
                </li>
                <li>
                  {" "}
                  Merchants must send the following parameters to the{" "}
                  <b className="para-blod">Safexpay</b> PG which is mandatory,
                  but values might be blank in case of optional or not required
                </li>
              </ul>

              <p className="para-underline">
                Please note only HTML Form Submission with the ‘POST’ method is
                supported. Sending payment requests using any REST API call is
                not supported.
              </p>
            </div>

            <div className="img-div">
              <img src="assets/images/Screenshot-code1.png" alt="logo" />
            </div>

            <div className="prgm-div">
              <p className="para-underline mt-2">
                Sample Request Before Encryption:
              </p>

              <p>
                {" "}
                <b className="para-blod">me_id :</b> 202308230001
              </p>
              <p>
                <b className="para-blod">merchant request :</b>{" "}
                paygate|202308230001|28933|16|ARE|AED|SALE|http://localhost/PHP_with_Checksum/trans
                action//Response.php|http://localhost/PHP_with_Checksum/transaction//Response.php|WEB~
                |||~||||~||||Y~||||~| |||||~||~~||||
              </p>
              <p>
                <b className="para-blod">Hash :</b>{" "}
                7be1cdd604ed19f2a8b573cd10236ecfdf1e2ff764f70088bac18cebd616a331
              </p>
            </div>

            <div className="prgm-div">
              <p className="para-underline mt-2">
                Sample Request After Encryption:
              </p>

              <p>
                <b className="para-blod">me_id :</b> 202308230001
              </p>
              <p>
                <b className="para-blod">merchant request :</b>{" "}
                DvGm+c3oOWRV7NtDHZQvryvY0WUfcz4ne8ApwtHqgSKy0a5Sc2gECraqaa/Cwjrl/rbYl71zdE63a+
                e6j0SpEZfj6FzQilNze/vvA0b3tz7sdNtFK3scCXm/530PsqCGfODRKsBxtD8kmeCgI+V9StMB46zPVHv
                Uma+kaNsj99B1M4YzJne8UwbicBkPNZz7fSdJ5Pv55Ix6zp7jeAVvxTF6xNjIhjp2e5EZwHmP19s+D
                T97UuDSHLrcNtoi56V3MmQFMR3CtEq781XxowlcEw==
              </p>
              <p>
                <b className="para-blod">Hash :</b>{" "}
                wbMe2SfTUjBH/19xwzVvL/N7BgeTyDAKGxEBYE7RUz0q9raevNUgb8YjCRHQECDbXe1ATg3
                wMct7yccOQWYwNosjTuh nG Az4OZlKuDRMueE=
              </p>

              <p className="para-underline ">
                Merchant_request will get encrypt by aes256 (Details shared
                below) :
              </p>

              <p>
                {" "}
                <b>
                  $all_values =
                  $txn_details.'~'.$pg_details.'~'.$card_details.'~'.$cust_details.'~'.$bill_details.'~'.$ship_details.'~'.
                  $item_details. '~'.$other_details;
                  $merchant_request['merchant_request'] =
                  $aes-encrypt($all_values, $merchant_key, 256);
                </b>
              </p>
              <p className="para-underline ">Encrypted Response:</p>
              <p>
                <b className="para-blod">txn_response :</b>{" "}
                DvGm+c3oOWRV7NtDHZQvrzXjCv3jEgaQqOgE05XkYfD+D2vlI82J32GWdhK7BEaeIEXGcnN7+PYW
                l1z+IAizDLX4jt8X4dlVr+DfdJoBFNlwCQJRP8Zv5k9fCtTlAJap/0Gl7w03TuEXn+pt8FMckV8K+8o/Jxh
                icigwsj3Gwyi0VRXdu687qMojVmRDHNN1OoJLT/C21+fFZvIH3uvfzhITYAPvmIf0dK839/RWc4h1A
                75KI4rPj9tcVN5L0o4JosHgqpPbv5Jb5My45p4wErCODnQUrTjT3rmK0gni8H7pRXGUhtYtSPi6YGd
                eWVOK
              </p>

              <p>
                <b className="para-blod">me_id: 202308230001</b>
              </p>

              <p>
                <b className="para-blod">pg_details : </b>
                pz5VIXq55ZK196AQfqythxqkBM0ymmqdIbpff1gBwbE=
              </p>
              <p>
                <b className="para-blod">fraud_details : </b>
                12qAKnsBgzQw4zmIZ8SHFQ==
              </p>
              <p>
                <b className="para-blod">other_details : </b>
                f46FM6eFYnnwXDhX3nzJdg==
              </p>

              <p className="para-underline ">Decrypted Response :</p>

              <p>
                <b className="para-blod">txn_response :</b>{" "}
                paygate|202308230001|28933|16.00|ARE|AED|2022-01-
                05|11:37:15.0|1078609015398245577|PG_1078609015398245577|Successful~pU0xFtiRFEDYM
                u1z36iacGXiDQd2OKyAuCjyUcR4AL9nNT6DqlYn0TxQ00f7Xh9t9jqlotZooGBtqyGGXcgSTp89MHY
                HO+RjeHCBkg4cRDs=~|0|Successful
              </p>

              <p>
                <b className="para-blod">me_id: 202308230003</b>
              </p>

              <p>
                <b className="para-blod">pg_details : </b> 629|Test Bank|CC|
              </p>
              <p>
                <b className="para-blod">fraud_details : </b> |NA|
              </p>
              <p>
                <b className="para-blod">other_details : </b> ||||NA|||||
              </p>
            </div>
          </div>
          <div class="col-md-4"></div>
        </div>
      </div>
    </div>
  );
}
export default AggHostedNonSeamless;
